import { DbId } from '@infotech-soe/metaschema';

import { AppState } from '../reducers/root';
import { IGraphData } from '../slices/graph';

export const getGraphShow = (state: AppState): boolean => state.graph.show;

export const getGraphNodes = (state: AppState): IGraphData[] =>
  state.graph.nodes;

export const getGraphDocId = (state: AppState): DbId => state.graph.docId;
